import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLineComponent } from './simple-icons-line.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLineComponent ],
    exports:      [ SimpleIconsLineComponent ],
    bootstrap:    []
})
export class SimpleIconsLineModule {}
